// from https://github.com/inspiraller/react-zod-next-intl/blob/main/src/zod/zodResolver.ts
// https://github.com/react-hook-form/resolvers/issues/799#issuecomment-3136267432
// To solve problem with form resolvers and zod not working

import type { FieldErrors, FieldValues, ResolverOptions, ResolverResult } from "react-hook-form"
import type { ZodType } from "zod"

export const zodResolver = <T extends FieldValues = FieldValues>(schema: ZodType<T>) => {
  return (values: T, _context?: any, _options?: ResolverOptions<T>): ResolverResult<T> => {
    const result = schema.safeParse(values)

    if (result.success) {
      return {
        values: result.data,
        errors: {},
      }
    } else {
      const fieldErrors: Record<string, any> = {}

      result.error.issues.forEach((issue) => {
        const fieldName = issue.path.join(".")
        if (fieldName && !fieldErrors[fieldName]) {
          fieldErrors[fieldName] = {
            type: issue.code,
            message: issue.message,
          }
        }
      })

      // console.log('Validation errors:', fieldErrors);

      return {
        values: {},
        errors: fieldErrors as FieldErrors<T>,
      }
    }
  }
}
